window.LawsonFridgeData = {
  "models": {
    "engel40": {
      "brand": "Engel",
      "model": "MT-V45F · 40L",
      "label": "Engel MT-V45F · 40L",
      "length": 751,
      "width": 360,
      "height": 508,
      "capacity": 40
    },
    "engel60": {
      "brand": "Engel",
      "model": "MT-V60F · 60L",
      "label": "Engel MT-V60F · 60L",
      "length": 910,
      "width": 525,
      "height": 441,
      "capacity": 60
    },
    "engel80": {
      "brand": "Engel",
      "model": "MT-V80F · 80L",
      "label": "Engel MT-V80F · 80L",
      "length": 910,
      "width": 490,
      "height": 561,
      "capacity": 80
    },
    "cfx535": {
      "brand": "Dometic",
      "model": "CFX5 35",
      "label": "Dometic CFX5 35",
      "length": 694,
      "width": 398,
      "height": 407,
      "capacity": 35
    },
    "cfx545": {
      "brand": "Dometic",
      "model": "CFX5 45",
      "label": "Dometic CFX5 45",
      "length": 694,
      "width": 398,
      "height": 476,
      "capacity": 45
    },
    "cfx555": {
      "brand": "Dometic",
      "model": "CFX5 55",
      "label": "Dometic CFX5 55",
      "length": 720,
      "width": 455,
      "height": 480,
      "capacity": 55
    },
    "cfx75": {
      "brand": "Dometic",
      "model": "CFX75DZW · original",
      "label": "Dometic CFX75DZW · original",
      "length": 887,
      "width": 495,
      "height": 472,
      "capacity": 75
    },
    "cfx375": {
      "brand": "Dometic",
      "model": "CFX3 75DZ",
      "label": "Dometic CFX3 75DZ",
      "length": 892,
      "width": 495,
      "height": 472,
      "capacity": 75
    },
    "cfx575": {
      "brand": "Dometic",
      "model": "CFX5 75DZ",
      "label": "Dometic CFX5 75DZ",
      "length": 892,
      "width": 495,
      "height": 472,
      "capacity": 75
    },
    "arb36": {
      "brand": "ARB",
      "model": "ZERO 36L",
      "label": "ARB ZERO 36L",
      "length": 675,
      "width": 423,
      "height": 436,
      "capacity": 36
    },
    "arb44": {
      "brand": "ARB",
      "model": "ZERO 44L",
      "label": "ARB ZERO 44L",
      "length": 675,
      "width": 423,
      "height": 496,
      "capacity": 44
    },
    "arb60": {
      "brand": "ARB",
      "model": "ZERO 60L",
      "label": "ARB ZERO 60L",
      "length": 755,
      "width": 469,
      "height": 496,
      "capacity": 60
    },
    "kings45": {
      "brand": "Kings",
      "model": "45L original · AKFR-FR45L001",
      "label": "Kings 45L original · AKFR-FR45L001",
      "length": 713,
      "width": 405,
      "height": 461,
      "capacity": 45
    },
    "kings60": {
      "brand": "Kings",
      "model": "60L original · AKFR-FR60L001",
      "label": "Kings 60L original · AKFR-FR60L001",
      "length": 768,
      "width": 470,
      "height": 461,
      "capacity": 60
    },
    "dune45": {
      "brand": "Dune 4WD",
      "model": "45L single zone",
      "label": "Dune 4WD 45L single zone",
      "length": 650,
      "width": 455,
      "height": 460,
      "capacity": 45,
      "source": "https://www.anacondastores.com/en-au/p/dune-4wd-45l-single-zone-fridgefreezer",
      "ventClearance": 150,
      "checked": "2026-10-14"
    },
    "dune75": {
      "brand": "Dune 4WD",
      "model": "75L dual zone",
      "label": "Dune 4WD 75L dual zone",
      "length": 900,
      "width": 485,
      "height": 460,
      "capacity": 75,
      "source": "https://www.anacondastores.com/en-au/p/dune-4wd-75l-dual-zone-fridgefreezer",
      "ventClearance": 150,
      "checked": "2026-10-14"
    },
    "evakoolRF47": {
      "brand": "EvaKool",
      "model": "Infinity RF 47L",
      "label": "EvaKool Infinity RF 47L",
      "length": 751,
      "width": 446,
      "height": 428,
      "capacity": 47,
      "source": "https://evakool.com.au/products/47l-infinity-rf-fibreglass-fridge-freezer",
      "checked": "2026-10-14",
      "ventClearance": 0
    },
    "evakoolRF60": {
      "brand": "EvaKool",
      "model": "Infinity RF 60L (custom build)",
      "label": "EvaKool Infinity RF 60L (custom build)",
      "length": 884,
      "width": 447,
      "height": 432,
      "capacity": 60,
      "source": "https://evakool.com.au/collections/all/products/60l-infinity-rf-fibreglass-fridge-freezer",
      "checked": "2026-10-14",
      "ventClearance": 0
    },
    "evakoolAdventure45": {
      "brand": "EvaKool",
      "model": "Adventure 45L",
      "label": "EvaKool Adventure 45L",
      "length": 677,
      "width": 394,
      "height": 544,
      "capacity": 45,
      "source": "https://evakool.com.au/products/45l-adventure-portable-single-zone-fridge",
      "checked": "2026-10-14",
      "ventClearance": 0
    },
    "evakoolDU50": {
      "brand": "EvaKool",
      "model": "Down Under II 50L",
      "label": "EvaKool Down Under II 50L",
      "length": 786,
      "width": 448,
      "height": 410,
      "capacity": 50,
      "source": "https://evakool.com.au/products/50l-down-under-fridge-freezer",
      "checked": "2026-10-14",
      "ventClearance": 0
    },
    "duneFrontier30": {
      "brand": "Dune 4WD",
      "model": "Frontier 2.0 30L (AK30)",
      "label": "Dune 4WD Frontier 2.0 30L (AK30)",
      "length": 610,
      "width": 330,
      "height": 400,
      "capacity": 30,
      "source": "https://www.anacondastores.com/en-au/p/dune-4wd-frontier-20-30l-single-zone-fridgefreezer/BP90268372-grey",
      "checked": "2026-10-14",
      "ventClearance": 150
    },
    "duneFrontier50": {
      "brand": "Dune 4WD",
      "model": "Frontier 50L (AK50)",
      "label": "Dune 4WD Frontier 50L (AK50)",
      "length": 675,
      "width": 425,
      "height": 460,
      "capacity": 50,
      "source": "https://www.anacondastores.com/en-au/p/dune-4wd-frontier-50l-single-zone-fridgefreezer",
      "checked": "2026-10-14",
      "ventClearance": 150
    },
    "xtm35": {
      "brand": "XTM",
      "model": "35L (677679)",
      "label": "XTM 35L (677679)",
      "length": 652,
      "width": 378,
      "height": 424,
      "capacity": 35,
      "source": "https://www.bcf.com.au/p/xtm-35l-fridge-freezer/677679.html",
      "checked": "2026-10-14",
      "ventClearance": 0
    },
    "xtmNGX55": {
      "brand": "XTM",
      "model": "NGX55 54L (677676)",
      "label": "XTM NGX55 54L (677676)",
      "length": 618,
      "width": 501,
      "height": 480,
      "capacity": 54,
      "source": "https://www.bcf.com.au/p/xtm-ngx55-54l-fridge-freezer/677676.html",
      "checked": "2026-10-14",
      "ventClearance": 0
    },
    "brassCFR30": {
      "brand": "Brass Monkey",
      "model": "CFR30 30L (GH2300)",
      "label": "Brass Monkey CFR30 30L (GH2300)",
      "length": 603,
      "width": 365,
      "height": 372,
      "capacity": 30,
      "source": "https://www.jaycar.com.au/30l-brass-monkey-portable-fridge-freezer-cfr30/p/GH2300",
      "checked": "2026-10-14",
      "ventClearance": 0
    },
    "brassCFR40": {
      "brand": "Brass Monkey",
      "model": "CFR40 40L (GH2302)",
      "label": "Brass Monkey CFR40 40L (GH2302)",
      "length": 603,
      "width": 365,
      "height": 442,
      "capacity": 40,
      "source": "https://www.jaycar.com.au/40l-brass-monkey-portable-fridge-freezer-cfr40/p/GH2302",
      "checked": "2026-10-14",
      "ventClearance": 0
    },
    "brassCFR50": {
      "brand": "Brass Monkey",
      "model": "CFR50 50L (GH2304)",
      "label": "Brass Monkey CFR50 50L (GH2304)",
      "length": 603,
      "width": 365,
      "height": 512,
      "capacity": 50,
      "source": "https://www.jaycar.com.au/50l-brass-monkey-portable-fridge-freezer-cfr50/p/GH2304",
      "checked": "2026-10-14",
      "ventClearance": 0
    }
  },
  "drawerFridges": {
    "drawerEngel30": {
      "label": "Engel 30 L drawer fridge",
      "layout": "enclosure30"
    },
    "drawerDometic30": {
      "label": "Dometic 30 L drawer fridge",
      "layout": "enclosure30"
    },
    "drawerKings30": {
      "label": "Kings 30 L drawer fridge",
      "layout": "enclosure30"
    },
    "drawerEvakool40": {
      "label": "EvaKool 40 L drawer fridge",
      "layout": "evakool40"
    }
  }
};
(function () {
 const data = window.LawsonFridgeData;
 data.limits = {plain50:475,plain60:575,hutch50:430,hutch60:530,length:1000};
 data.matches = (model,slide,hutch,hutch60=530) => Number.isFinite(model.width) && model.width > 0 && Number.isFinite(model.length) && model.length > 0 && model.length <= data.limits.length && model.width <= (hutch ? slide === '50' ? data.limits.hutch50 : hutch60 : slide === '50' ? data.limits.plain50 : data.limits.plain60);
 data.populate = (select,drawerLabel) => {
  const retained = select.value; const none = select.querySelector('option[value="none"]'); const custom = select.querySelector('option[value="custom"]');
  const start = none ? none.cloneNode(true) : new Option('Select a fridge','none');
  select.replaceChildren(start); const groups = {};
  for(const [id,model] of Object.entries(data.models)) { if(!groups[model.brand]) { const group=document.createElement('optgroup'); group.label=model.brand;groups[model.brand]=group;select.append(group); } groups[model.brand].append(new Option(model.model,id)); }
  const drawers=document.createElement('optgroup');drawers.label=drawerLabel;
  for(const [id,model] of Object.entries(data.drawerFridges))drawers.append(new Option(model.label,id));
  select.append(drawers,custom ? custom.cloneNode(true) : new Option('Enter my fridge details','custom')); select.value = retained || 'none';
 };
})();
